import { render, staticRenderFns } from "./passengers-info.vue?vue&type=template&id=5b7906ab&scoped=true"
import script from "./passengers-info.vue?vue&type=script&lang=js"
export * from "./passengers-info.vue?vue&type=script&lang=js"
import style0 from "./passengers-info.vue?vue&type=style&index=0&id=5b7906ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7906ab",
  null
  
)

export default component.exports